angular.module('cian.advancedBrowser')
  .directive('advancedFilters', ['FilterService', FilterService => {
    const templates = {
      flat: require('../../templates/flat.html'),
      newBuilding: require('../../templates/flat_newbuilding.html'),
      suburban: require('../../templates/suburban.html'),
      commercial: require('../../templates/commercial.html'),
    };

    return {
      scope: true,
      template: () => {
        const templateName = FilterService.isNewBuilding() ?
          'newBuilding' :
          FilterService.category;
        return templates[templateName];
      },
      restrict: 'E',
    };
  }]);



// WEBPACK FOOTER //
// ./src/components/advanced-browser/src/scripts/cian.advanced-filters.dir.js